import React from 'react';
import './404.css';

function page404() {
  return (
    <div className="container">
      <h1>404</h1>
      <p>página não encontrada</p>
    </div>
  );
}

export default page404;
